// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"644":"account","651":"simuam"}[chunkId] + "." + {"644":"59c8003d","651":"6ab1477f"}[chunkId] + ".css";
};